export const generateUniqueID = (): string => {
  const array = new Uint32Array(4)
  window.crypto.getRandomValues(array) // [12343643543, 234324234]

  return Array.from(array, num => num.toString(36)).join('') // 'a35fjyu87654'
}